var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlpaca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5c0 2 1.167 3.667 2 4.5v16.19l2.618 1.31h6.776L21 24.342V8c.333-.5 1.1-1.7 1.5-2.5.5-1 2-4-.5-4-2 0-3.833 2.333-4.5 3.5H12c0-.167-.1-.7-.5-1.5s-2.167-1.667-3-2C8 1.333 7 1.5 7 3.5zM22.64 24.708 18.604 26.5h-7.224L7.5 24.56v5.94H19l5.5-3-1.861-2.792zM13.998 12c0 .552-.895 1-2 1s-2-.448-2-1 .895-1 2-1 2 .448 2 1zm6 0c0 .552-.895 1-2 1s-2-.448-2-1 .895-1 2-1 2 .448 2 1zm-3.667 2.833c0 .026 0 .05-.002.076 1.556.182 2.67.676 2.67 1.257 0 .736-1.79 1.333-4 1.333s-4-.597-4-1.333c0-.581 1.114-1.075 2.669-1.258a1.333 1.333 0 1 1 2.664-.076z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpaca);
export default __webpack_public_path__ + "static/media/ALPACA.d7ec303a138062764cae13ea06671072.svg";
export { ForwardRef as ReactComponent };